// extracted by mini-css-extract-plugin
export default {"errorPage":"errorPage--ipauy","imageWrapper":"imageWrapper--ipauy","heading":"heading--ipauy","gotoLink":"gotoLink--ipauy"};